import { jsx } from 'react/jsx-runtime';
import { Component } from 'react';
import { isBrowser } from '../../tools/env.js';
import 'nanoid';
import '../../tools/dom.js';
import 'timen';
import 'compareq';
import 'lodash.pick';
import '../../tools/queryParams.js';

const getVH = () => (isBrowser ? window.innerHeight / 100 : 0);
class VH extends Component {
    constructor(props) {
        super(props);
        this.state = { vh: 0 };
    }
    componentDidMount() {
        this.updateVH();
        window.addEventListener('resize', this.updateVH);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateVH);
    }
    updateVH = () => {
        this.setState({ vh: getVH() });
    };
    render() {
        const { vh } = this.state;
        return jsx("style", { children: `:root{--vh: ${vh}px;}` });
    }
}

export { VH };
